export * from 'js/components/main/Games/constants';
export const T_KEYS_NO_BECAUSE_YOU_PLAYED_GAMES = 'playtech.mobile.game-categories.lobby_spiele_pgg2.noGame.because_you_played-all';
export const RECOMMENDED_CATEGORIES = ['recommended-all-dynamic-category-recommended-all', 'recommended-live-dynamic-category-recommended-live'];
